var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"empty":!_vm.articles.length > 0,"empty-text":_vm.empty}},[_c('template',{slot:"header"},[_c('h1',[_vm._v("Events")])]),_c('articles',{attrs:{"articles":_vm.articles}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }